module.exports = __webpack_public_path__ + "static/img/min1.6b577f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/agent/min1.png
// module id = vAI+
// module chunks = 1